import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, SxProps, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import authService from "../../../services/authService";

type PageTitleProps = {
  title: string;
  backButton?: boolean;
  backRoute?: string;
  containerSx?: SxProps;
};

const PageTitle = ({
  title,
  backButton = true,
  backRoute,
  containerSx,
}: PageTitleProps) => {
  const history = useHistory();
  const bypassToken = authService.getBypassToken();

  return (
    <Box
      sx={{
        display: "flex",
        gap: "10px",
        alignItems: "center",
        ...containerSx,
      }}
    >
      {!bypassToken && backButton && (
        <IconButton
          onClick={() =>
            backRoute ? history.push(backRoute) : history.goBack()
          }
        >
          <ArrowBack />
        </IconButton>
      )}
      <Typography variant="h5" fontWeight="bold">
        {title}
      </Typography>
    </Box>
  );
};

export default PageTitle;
